/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationEffectDateMutation($input: SaveSimulationEffectDate_M_simulation_effect_dateInput!) {
    saveSimulationEffectDate_M_simulation_effect_date(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
